export const API_URL = "https://fb-api.com/"
export const API_URL_AGRNCY_LV2 = "https://sv2.fb-api.com/api"
export const API_SUPPORT = "https://hotro.findids.net/api"
